import {BrowserRouter, Route, Routes} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ConferenceWrap from "./component/views/ConferenceWrap";
import ErrorBoundary from "./component/general/ErrorBoundary";
import InLayer from "./component/general/InLayer";

// RISKS.md/P2.77: the last resort, for a failure above the routes' boundary (the providers and
// their notifiers). No router or context is left here, so only a reload leads back; never
// automatically, or a failure that repeats would reload for ever.
const PageFailed = () => {
  const {t} = useTranslation()
  return (
    <InLayer
      title={t('chat.sessionFailed.title')}
      btnConfirmLabel={t('pageFailed.reload')}
      onConfirm={() => window.location.reload()}
    >
      {t('pageFailed.message')}
    </InLayer>
  )
}

export default () => (
  <ErrorBoundary fallback={() => <PageFailed/>}>
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<ConferenceWrap/>}/>
      </Routes>
    </BrowserRouter>
  </ErrorBoundary>
)
